import { api } from './api';

export const obtenerHorasVoluntariado = (id, page = 0, size = 20) => {
  return api.get(`/personalbibliotecario/${id}/horas`, { params: { page, size } });
};

export const ajustarHorasVoluntariado = (id, ajuste) => {
  return api.post(`/personalbibliotecario/${id}/horas/ajustes`, ajuste);
};
